// src/pages/AddClientRolePage.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { staffApi } from "../Apis/Api";
import Breadcrumb from "../components/Breadcrumb";
import { CancelButtonForm, UpdateButtonForm } from "../components/ui/Button";
import { handleApiResponse, handleCustomResponse } from "../utils/response";

const AddClientRolePage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    role_name: "",
    description: "",
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.role_name.trim())
      newErrors.role_name = "Role name is required";
    // else if (!formData.description.trim())
    //   newErrors.description = "Description is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      // Show validation errors as toasts
      Object.values(newErrors).forEach((error) => {
        // handleCustomResponse("error", error);
      });
      return;
    }

    try {
      setIsLoading(true);
      const response = await staffApi.createClientRole(formData);
      if (response.success) {
        handleApiResponse(response, "success", "POST");
        navigate(-1);
      } else {
        handleCustomResponse("error", "Failed to create client role");
      }
    } catch (error) {
      handleApiResponse(error, "ERR", "POST");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Add Role" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form onSubmit={handleSubmit}>
            <div className="row g-20">
              <div className="col-md-6 mb-20">
                <label
                  htmlFor="role_name"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Role Name <span className="text-danger-600">*</span>
                </label>
                <input
                  type="text"
                  id="role_name"
                  name="role_name"
                  value={formData.role_name}
                  onChange={handleChange}
                  placeholder="Enter Role Name"
                  className="form-control radius-8"
                  style={{
                    border: errors.role_name ? "1px solid #e53e3e" : "",
                  }}
                />
                {errors.role_name && (
                  <span className="text-sm text-danger-600 mt-2 d-block">
                    {errors.role_name}
                  </span>
                )}
              </div>
              <div className="col-md-6 mb-20">
                <label
                  htmlFor="description"
                  className="form-label fw-semibold text-primary-light text-sm mb-8"
                >
                  Description 
                  {/* <span className="text-danger-600">*</span> */}
                </label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Enter Description"
                  className="form-control radius-8"
                  rows="4"
                  style={{
                    border: errors.description ? "1px solid #e53e3e" : "",
                  }}
                />
                {errors.description && (
                  <span className="text-sm text-danger-600 mt-2 d-block">
                    {errors.description}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center gap-3">
              <CancelButtonForm />
              <UpdateButtonForm disabled={isLoading} />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddClientRolePage;